module.exports = __webpack_public_path__ + "static/media/house_tyrell.df512deb.png";